import crmContactService from './crm.contact.service';
import crmPipelineService from './crm.pipeline.service';
import crmStatusService from './crm.status.service';
import loginService from '../login.service';
import masks from '../../../providers/masks';

const getCurrentUserSellerId = () => {
    const currentUser = loginService.getUserAuthentication();
    return currentUser?.sellerId;
}

const filtersExtraInfoByName = {
    pipelineUuid: {
        getOptions: () => getPipelineOptions()
    },
    contactId: {
        searchOptions: (searchValue) => getContactOptionsByName(searchValue),
        minSearchChars: 3,
        searchDebounceMs: 500
    },
    statusName: {
        getOptions: () => getStatusOptions()
    },
    contactPhone: {
        mask: masks.cellPhone
    },
}

const getPipelineOptions = () =>
    crmPipelineService
        .findBySellerId(getCurrentUserSellerId())
        .then(pipelines => pipelines.map(pipeline => ({ ...pipeline, value: pipeline.uuid })));

const getStatusOptions = () =>
    crmStatusService
        .findBySellerId(getCurrentUserSellerId())
        .then(status => status.map(status => ({ ...status, value: status.name })));

const getContactOptionsByName = (searchValue) =>
    crmContactService
        .findByNamePartial(searchValue)
        .then(contacts => contacts.map(contact => ({ ...contact, value: contact.id })));

const getFiltersWithExtraInfo = (filters = []) =>
    filters.map(filter => ({
        ...filter,
        ...filtersExtraInfoByName[filter.name]
    }));

export default {
    getFiltersWithExtraInfo,
}
